import { render, staticRenderFns } from "./educationalProgram.vue?vue&type=template&id=86295cbe&scoped=true"
import script from "./educationalProgram.vue?vue&type=script&lang=js"
export * from "./educationalProgram.vue?vue&type=script&lang=js"
import style0 from "./educationalProgram.vue?vue&type=style&index=0&id=86295cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86295cbe",
  null
  
)

export default component.exports